/*
 * @Author: changcheng
 * @LastEditTime: 2023-08-02 16:18:25
 */
import React, { useEffect, FC, useState, useRef } from "react";
import { connect } from "react-redux";
import { Carousel, message } from "antd";
import "./index.less";
import axios from "@/axios/axios";
import { RightOutlined, LeftOutlined } from "@ant-design/icons";

const contentStyle = {
  height: "334px",
  width: "900px",
};
const CarouselModule: FC<any> = ({ history, list = [] }) => {
  const myCarousel: any = useRef();

  const imgJump = (data: any) => {
    if (data.clickUrl) {
      window.open(data.clickUrl);
    }
  };

  // banner 列表
  const [bannerList, setBannerList] = useState([]);
  const getBanner = async () => {
    const { code, data, msg }: any = await axios.post(
      "/main/front/ce/banner/list"
    );
    if (code === 0) {
      setBannerList(data || []);
    } else {
      message.error(msg);
    }
  };

  useEffect(() => {
    getBanner();
  }, []);

  return (
    <div className={"carousel-module"}>
      <div style={{ width: "100%", margin: "0 auto" }}>
        <Carousel ref={myCarousel} autoplay={true}>
          {bannerList.map((banner: any, i: number) => (
            <div key={i}>
              <div style={contentStyle}>
                <img
                  onClick={() => {
                    imgJump(banner);
                  }}
                  style={{ width: "900px", height: "100%", cursor: "pointer" }}
                  src={banner.imageAllPathUrl}
                  alt=""
                />
              </div>
            </div>
          ))}
        </Carousel>
      </div>
      <div
        className={"previous"}
        onClick={() => {
          myCarousel.current.prev();
        }}
      >
        <LeftOutlined style={{ color: "#fff", fontSize: "20px" }} />
      </div>
      <div
        className={"next"}
        onClick={() => {
          myCarousel.current.next();
        }}
      >
        <RightOutlined style={{ color: "#fff", fontSize: "20px" }} />
      </div>
    </div>
  );
};

export default connect((state) => state)(CarouselModule);
